// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PWrenchOutlinedSvg from "@fishx/icons-svg/es/asn/PWrenchOutlined";
import FishxIcon from '../components/FishxIcon';

var PWrenchOutlined = function PWrenchOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PWrenchOutlinedSvg
  }));
};

PWrenchOutlined.displayName = 'PWrenchOutlined';
export default React.forwardRef(PWrenchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PWrenchOutlined.js
// module id = 3742
// module chunks = 0